import { CARRY_OVER_FIELDS } from '../constants/constants';

function randomFromChars(chars: string, length: number) {
  const values = new Uint32Array(length);
  crypto.getRandomValues(values);
  return Array.from(values, (value) => chars[value % chars.length]).join('');
}

function shuffleString(value: string) {
  const chars = value.split('');
  for (let i = chars.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [chars[i], chars[j]] = [chars[j], chars[i]];
  }
  return chars.join('');
}

export function generateApiKey() {
  return randomFromChars(
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
    32,
  );
}

export function generateSecretKey() {
  const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  const digits = '0123456789';
  const specials = '!@#$%^&*()-_=+[]{}';
  const all = `${letters}${digits}${specials}`;
  const seed =
    randomFromChars(letters, 12) +
    randomFromChars(digits, 12) +
    randomFromChars(specials, 8) +
    randomFromChars(all, 8);
  return shuffleString(seed);
}

export function isValidUrl(value: string) {
  if (!value.trim()) return true;
  try {
    const url = new URL(value);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
}

export function parseDeveloperSettings(data: Record<string, unknown>) {
  return {
    webhookUrl: String(data.webhookUrl ?? ''),
    redirectUrl: String(data.redirectUrl ?? ''),
    logoUrl: String(data.logoUrl ?? ''),
    apiKey: String(data.merchantKey ?? ''),
    secretKey: String(data.merchantSecret ?? ''),
  };
}

export function buildDeveloperUpdatePayload(
  merchantId: number,
  record: Record<string, unknown>,
  settings: {
    webhookUrl: string;
    redirectUrl: string;
    logoUrl: string;
    apiKey: string;
    secretKey: string;
  },
) {
  const payload: Record<string, unknown> = { merchantId };
  for (const field of CARRY_OVER_FIELDS) {
    payload[field] = record[field] ?? null;
  }
  payload.webhookUrl = settings.webhookUrl.trim();
  payload.redirectUrl = settings.redirectUrl.trim();
  payload.logoUrl = settings.logoUrl.trim() || undefined;
  payload.merchantKey = settings.apiKey.trim() || undefined;
  payload.merchantSecret = settings.secretKey.trim() || undefined;
  return payload;
}
